(function(){
'use strict';

var OCCASION_CONFIG = {
  any:         { label:'Any Occasion',  colKeywords:[], tagKeywords:[] },
   christmas:        { label:'Christmas Hampers',          colKeywords:['all-christmas-hampers-2026'],       tagKeywords:[] },
  winter:        { label:'Winter',          colKeywords:['autumn-winter-hampers','winter'],       tagKeywords:['AUTUMN NEW'] },
  baby:     { label:'Baby Hampers',      colKeywords:[ 'baby-hampers'],
                                        tagKeywords:[] },
  baskets:    { label:'Hamper Baskets',      colKeywords:['gift-basket'],
                                        tagKeywords:[''] },
  birthday:    { label:'Birthday',      colKeywords:['trending-birthday-hampers', 'baby-birthday-hampers', 'birthday-hampers-for-kids', 'milestone-birthdays'],     tagKeywords:[] },
  anniversary: { label:'Anniversary',   colKeywords:['anniversary-hampers'],  tagKeywords:['ANNIVERSARY PRODUCTS'] },
  thankyou:    { label:'Thank You',     colKeywords:['thank-you-hampers', 'thank-you-corporate-hampers'],
                                        tagKeywords:[''] },
  wedding:     { label:'Wedding',       colKeywords:['wedding-hampers', 'engagement-hampers', 'groomsman-best-man-hampers' , 'bridesmaid-maid-of-honour-hampers'],
                                        tagKeywords:[] },
  newbaby:     { label:'Baby Shower',      colKeywords:[ 'baby-shower-gifts'],
                                        tagKeywords:[] },
  getwell:     { label:'Get Well',      colKeywords:['get-well-soon-hampers'],
                                        tagKeywords:[''] },
  congrats:    { label:'Congrats',      colKeywords:['congrats-hampers'],
                                        tagKeywords:[''] }
};

var ALL_OCCASIONS = ['any','christmas','baskets','baby','birthday','anniversary','thankyou','wedding','newbaby','getwell','congrats'];

var RECIPIENT_OPTIONS = [
  { val:'anyone',  label:'Anyone',   kws:[] },
  { val:'babyboy',  label:'Baby Boy',   kws:['Baby Boy'] },
  { val:'babygirl',  label:'Baby Girl',   kws:['Baby Girl'] },
  { val:'unisex',  label:'Unisex Baby',   kws:['Unisex Baby'] },
  { val:'forhim',  label:'For Him',  kws:['for him','for-him','forhim','him','men','man','male','groom','groomsman','groomsmen','dad','father','husband','boyfriend','brother'] },
  { val:'forher',  label:'For Her',  kws:['Brides Maid','Bride & Bride', 'bride', 'Bride & Groom', 'for her','for-her','forher','her','women','woman','female','bride','bridesmaid','mum','mum','mom','wife','girlfriend','sister','daughter'] },
   { val:'toshare', label:'Hampers to Share', kws:['Sharing'] },
  { val:'forkids', label:'For Kids', kws:['CHRISTMAS FOR KIDS', 'Gifts for Kids', 'Gifts for Kids', 'Kids Hampers', 'for kids','forkids','kids','children'] }
];

var BUDGET_OPTIONS = [
  { val:'anyprice', label:'Any Price',   min:0,   max:999999 },
  { val:'under99',  label:'Under $99',   min:0,   max:99.99 },
  { val:'b100149',  label:'$100 - $149', min:100, max:149.99 },
  { val:'b150199',  label:'$150 - $199', min:150, max:199.99 },
  { val:'over200',  label:'$200+',       min:200, max:999999 }
];

var PER = 4;

/* 
   HIDDEN TAGS / TYPES
 */
var HIDDEN_TAGS = [
  'import gba','easify box builder','searchanise_ignore','personalize','cyo',
  'general-bundles','extras products','cyo-personalise','cyo-snacks',
  'cards','cyo-beverage','basket designs','extras','extranew',
  'extra bundles','extra','content 18','cyo sweets'
];
var HIDDEN_TYPES = ['CYO Hamper', 'content extras','corporate branding','box builder','extras - cookies','sleeves','extras - christmas'];

var ICONS = {
  'any-occ':   '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M12 6l1.5 3.5H17l-2.8 2 1 3.5L12 13l-3.2 2 1-3.5L7 9.5h3.5z" stroke="white" stroke-width="1.2" stroke-linejoin="round"/></svg>',
  baskets:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="12" fill="#333"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4 10.0265C4.00395 9.73613 4.20233 9.51188 4.48479 9.45725C5.36921 9.45402 6.25327 9.44971 7.13696 9.44432C7.85715 8.37806 8.57374 7.30892 9.28637 6.23691C9.75392 5.64072 10.6387 6.28327 10.2143 6.91613C9.66731 7.73694 9.11998 8.55738 8.5723 9.37783C8.56367 9.40155 8.53025 9.4188 8.55397 9.44324C10.8845 9.45402 13.215 9.45402 15.5456 9.4436C15.5488 9.43893 15.5517 9.43425 15.5549 9.42958C15.0054 8.59584 14.4531 7.76425 13.8971 6.93446C13.4475 6.31238 14.3176 5.6285 14.8128 6.23691C15.5262 7.30856 16.2424 8.3777 16.9622 9.44396C17.8463 9.44935 18.73 9.45402 19.6144 9.45725C20.2677 9.58483 20.258 10.5009 19.5788 10.5993C19.3747 10.6019 19.1709 10.6022 18.9668 10.6008C18.9309 10.6004 18.9089 10.618 18.901 10.6529C18.7472 12.4623 18.5934 14.2718 18.44 16.0812C18.2786 16.8858 17.631 17.4519 16.8113 17.4997C13.6847 17.5015 10.5582 17.5022 7.43165 17.5015C6.57095 17.5212 5.85149 16.9556 5.66713 16.1154C5.65311 16.0083 5.63946 15.9015 5.6258 15.7944C5.48313 14.0806 5.34046 12.3667 5.19815 10.6529C5.19024 10.618 5.16832 10.6004 5.13238 10.6008C4.6537 10.6144 4.03881 10.678 4 10.0265ZM8.59961 12.3984C8.59674 13.3697 8.59961 14.3411 8.6086 15.3122C8.75989 15.9331 9.60514 15.9321 9.74349 15.2906C9.75284 14.2657 9.75176 13.2407 9.74026 12.2158C9.57207 11.5057 8.55289 11.653 8.59961 12.3984ZM11.4746 12.3984C11.4717 13.3697 11.4746 14.3411 11.4836 15.3122C11.6349 15.9331 12.4801 15.9321 12.6185 15.2906C12.6278 14.2657 12.6267 13.2407 12.6152 12.2158C12.4471 11.5057 11.4279 11.653 11.4746 12.3984ZM14.3496 12.3984C14.3467 13.3697 14.3496 14.3411 14.3586 15.3122C14.5099 15.9331 15.3551 15.9321 15.4935 15.2906C15.5028 14.2657 15.5017 13.2407 15.4902 12.2158C15.322 11.5057 14.3029 11.653 14.3496 12.3984Z" fill="white" stroke="white" stroke-width="0.5"/> </svg>',
  christmas:   '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"></rect><path d="M12 5.8l2.1 3.5h-1.4l2.1 3.3h-1.4l2.1 3.4H8.5l2.1-3.4H9.2l2.1-3.3H9.9L12 5.8z" fill="white"></path><rect x="11.25" y="15.9" width="1.5" height="2.1" fill="white"></rect><circle cx="12" cy="6.4" r="0.9" fill="white"></circle></svg>',
  baby:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="10" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8.5 17.5c0-2 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  winter:        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="11" width="10" height="7" rx="1.5" fill="white" opacity="0.92"/><rect x="11.2" y="11" width="1.6" height="7" fill="#333" opacity="0.18"/><rect x="6.5" y="9" width="11" height="3" rx="1.2" fill="white"/><path d="M10.5 9C9.3 9 8.7 8.2 8.7 7.5C8.7 6.8 9.2 6.3 9.9 6.3C10.7 6.3 11.3 7 12 8C12.7 7 13.3 6.3 14.1 6.3C14.8 6.3 15.3 6.8 15.3 7.5C15.3 8.2 14.7 9 13.5 9H10.5Z" fill="white" opacity="0.95"/></svg>',
  birthday:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="12" width="10" height="6" rx="1" stroke="white" stroke-width="1.3"/><path d="M9 12V11M12 12V10M15 12V11" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  anniversary: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M12 17s-5-3.5-5-7a3 3 0 015-2.2A3 3 0 0117 10c0 3.5-5 7-5 7z" stroke="white" stroke-width="1.3" stroke-linejoin="round"/></svg>',
  thankyou:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M8 12l3 3 5-5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  wedding:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="9.5" cy="13" r="2.5" stroke="white" stroke-width="1.3"/><circle cx="14.5" cy="13" r="2.5" stroke="white" stroke-width="1.3"/><path d="M12 8v3" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  newbaby:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="10" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8.5 17.5c0-2 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  getwell:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="7" width="10" height="10" rx="2" stroke="white" stroke-width="1.3"/><path d="M12 9.5v5M9.5 12h5" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  congrats:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M7 17l4-9 2 5 2-3 2 4" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  anyone:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="9.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><circle cx="14.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><path d="M6 17c0-2 1.567-3.5 3.5-3.5S13 15 13 17" stroke="white" stroke-width="1.3" stroke-linecap="round"/><path d="M13 15c.4-.33.9-.5 1.5-.5C16.433 14.5 18 16.067 18 18" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  forhim:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="10" r="3" stroke="white" stroke-width="1.4"/><path d="M7 19c0-2.761 2.239-5 5-5s5 2.239 5 5" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  forher:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9.5" r="3" stroke="white" stroke-width="1.4"/><path d="M12 12.5v4M10 15h4" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
   toshare:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9.5" r="3" stroke="white" stroke-width="1.4"/><path d="M12 12.5v4M10 15h4" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  forkids:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8 18c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="white" stroke-width="1.3" stroke-linecap="round"/><path d="M9 7c.5-1.5 1.5-2 3-2" stroke="white" stroke-width="1.1" stroke-linecap="round"/></svg>',
  anyprice:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="16" text-anchor="middle" fill="white" font-size="9" font-family="sans-serif" font-weight="bold">Any</text></svg>',
  under99:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="7.5" font-family="sans-serif" font-weight="bold">&lt;$99</text></svg>',
  b100149:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$100-149</text></svg>',
  b150199:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$150-199</text></svg>',
  over200:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="8" font-family="sans-serif" font-weight="bold">$200+</text></svg>'
};


function yieldToMain() {
  /* Use scheduler.yield() when available (Chrome 115+),
     otherwise fall back to a 0ms setTimeout. */
  if (typeof scheduler !== 'undefined' && scheduler.yield) {
    return scheduler.yield();
  }
  return new Promise(function(resolve) { setTimeout(resolve, 0); });
}
/* Process large arrays in small batches, yielding to the main thread
   between each batch so clicks/taps don't get stuck behind this work. */
function normalizeInChunks(raw, chunkSize) {
  chunkSize = chunkSize || 50;
  var out = [];
  var i = 0;

  function step() {
    var end = Math.min(i + chunkSize, raw.length);
    for (; i < end; i++) {
      var p = normalizeProduct(raw[i]);
      if (p && p.title) out.push(p);
    }
    if (i < raw.length) return yieldToMain().then(step);
    return out;
  }

  return step();
}


var S = { occasion:null, recipient:null, budget:null };

var allProducts    = [];
var allCollections = [];
var occPool        = [];
var recPool        = [];
var finalPool      = [];


function init() {
  buildOccasionDropdown();
  bindTrigger('occasion');
  bindTrigger('recipient');
  bindTrigger('budget');
  bindFind();
  bindRestart();

  document.addEventListener('click', closeAll, { passive: true });
  /* Prefetch collections in the background don't block init. */
  setTimeout(fetchAllCollections, 0);
}

function fetchAllCollections() {
  var all = [];
  function fetchPage(page) {
    return fetch('/collections.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cols = data.collections || [];
        all = all.concat(cols);
        if (cols.length === 250) return fetchPage(page + 1);
        return all;
      })
      .catch(function() { return all; });
  }
  fetchPage(1).then(function(cols) { allCollections = cols; });
}

function fetchCollectionProducts(handle) {
  var all = [];
  function fetchPage(page) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var prods = data.products || [];
        all = all.concat(prods);
        if (prods.length === 250) return fetchPage(page + 1);
        return all;
      })
      .catch(function() { return all; });
  }
  return fetchPage(1).then(function(raw) {
    return normalizeInChunks(raw, 50);
  });
}

function fetchSampleProducts() {
  if (allProducts.length > 0) return Promise.resolve(allProducts);

  var pages = ['/products.json?limit=250&page=1', '/products.json?limit=250&page=2', '/products.json?limit=250&page=3'];

  return Promise.all(pages.map(function(url) {
    return fetch(url).then(function(r) { return r.json(); }).catch(function() { return { products: [] }; });
  })).then(function(results) {
    var raw = [];
    results.forEach(function(d) { raw = raw.concat(d.products || []); });
    return normalizeInChunks(raw).then(function(products) {
      allProducts = products;
      return allProducts;
    });
  });
}

function normalizeProduct(p) {
  if (!p) return null;
  var variant  = (p.variants && p.variants[0]) || {};
  var price    = parseFloat(variant.price || '0');
  var img      = (p.images && p.images[0]) ? p.images[0].src : '';
  var tags     = Array.isArray(p.tags)
    ? p.tags
    : String(p.tags||'').split(',').map(function(t){ return t.trim(); }).filter(Boolean);
  var normTags = tags.map(function(t){ return t.toLowerCase().trim(); });
  var isHidden = HIDDEN_TAGS.some(function(ht){ return normTags.indexOf(ht) !== -1; });
  var isHiddenType = HIDDEN_TYPES.indexOf(String(p.product_type || '').toLowerCase().trim()) !== -1;
  if (isHidden || isHiddenType) return null;
  return {
    id:             p.id,
    title:          p.title || '',
    product_type:   String(p.product_type || '').toLowerCase(),
    price:          price,
    image:          img,
    url:            '/products/' + p.handle,
    variant_id:     variant.id || '',
    handle:         p.handle || '',
    variants_count: (p.variants || []).length,
    tags:           normTags
  };
}

/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   STEP 1: OCCASION
â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildOccasionDropdown() {
  var drop = document.getElementById('gba-drop-occasion');
  drop.innerHTML = '';
  /* INP fix: build all options in one go using a DocumentFragment
     to avoid repeated reflows. */
  var frag = document.createDocumentFragment();
  ALL_OCCASIONS.forEach(function(key) {
    var cfg     = OCCASION_CONFIG[key]; if (!cfg) return;
    var iconKey = key === 'any' ? 'any-occ' : key;
    var opt     = makeOpt(iconKey, cfg.label, true, function(k, c){ return function(){ onOccasionSelected(k, c.label, c); }; }(key, cfg));
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
}

function onOccasionSelected(val, label, cfg) {
  S.occasion = val;
  markPicked('occasion', val === 'any' ? 'any-occ' : val);
  setLabel('occasion', label, val === 'any' ? 'any-occ' : val);
  closeAll();
  resetStep('recipient'); resetStep('budget'); disableFind();
  stepLoading(true);

  if (val === 'any') {
    fetchSampleProducts().then(function() {
      occPool = applyHiddenTagFilter(allProducts);
      stepLoading(false);
      /* INP fix: yield before building dropdown so paint can happen first */
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
    return;
  }

  var colKws = cfg.colKeywords || [];

  function colMatchPriority(col) {
    var handle = (col.handle || '').toLowerCase().trim();
    for (var i = 0; i < colKws.length; i++) {
      if (handle === colKws[i].toLowerCase().trim()) return i; // lower index = higher priority
    }
    return -1; // no match
  }

  var matchedCols = allCollections.filter(function(col){ return colMatchPriority(col) !== -1; });
  matchedCols.sort(function(a, b){ return colMatchPriority(a) - colMatchPriority(b); });

  if (matchedCols.length > 0) {
    Promise.all(matchedCols.map(function(col){ return fetchCollectionProducts(col.handle); }))
    .then(function(arrays) {
      var seen = {}, merged = [];
      arrays.forEach(function(arr){ arr.forEach(function(p){ if (!seen[p.id]){ seen[p.id]=true; merged.push(p); } }); });
      occPool = merged;
      stepLoading(false);
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
  } else {
    fetchSampleProducts().then(function() {
      occPool = applyHiddenTagFilter(allProducts);
      stepLoading(false);
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
  }
}

function applyHiddenTagFilter(products) {
  return products.filter(function(p) {
    return !HIDDEN_TAGS.some(function(ht){ return p.tags.indexOf(ht) !== -1; });
  });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• RECIPIENT HELPERS â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function productHasRecipientTag(p, rec) {
  if (rec.val === 'anyone') return true;
  return rec.kws.some(function(kw){
    return p.tags.indexOf(kw.toLowerCase().trim()) !== -1;
  });
}
function productMatchesRecipient(p, rec) {
  if (rec.val === 'anyone') return true;
  var hay = (p.title + ' ' + p.url + ' ' + p.handle + ' ' + p.tags.join(' ')).toLowerCase();
  return rec.kws.some(function(kw){ return hay.indexOf(kw) !== -1; });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• STEP 2: RECIPIENT â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildRecipientDropdown() {
  var drop = document.getElementById('gba-drop-recipient');
  drop.innerHTML = '';
  /* INP fix: pre-compute availability outside the loop, avoid
     repeated .some() calls inside makeOpt (they're O(n) each). */
  var poolHasRecipientTags = occPool.some(function(p){
    return RECIPIENT_OPTIONS.slice(1).some(function(r){ return productHasRecipientTag(p, r); });
  });
  var frag = document.createDocumentFragment();
  RECIPIENT_OPTIONS.forEach(function(rec) {
    var avail;
    if (rec.val === 'anyone')       avail = true;
    else if (!poolHasRecipientTags) avail = false;
    else avail = occPool.some(function(p){ return productHasRecipientTag(p, rec); });
    var opt = makeOpt(rec.val, rec.label, avail, avail ? (function(r){ return function(){ onRecipientSelected(r); }; }(rec)) : null);
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
  rebindTrigger('recipient');
}

function onRecipientSelected(rec) {
  S.recipient = rec;
  markPicked('recipient', rec.val);
  setLabel('recipient', rec.label, rec.val);
  closeAll();

  /* INP fix: defer the filter loop so the label update paints first */
  yieldToMain().then(function() {
    if (rec.val === 'anyone') {
      recPool = occPool.slice();
    } else {
      var poolHasRecipientTags = occPool.some(function(p){
        return RECIPIENT_OPTIONS.slice(1).some(function(r){ return productHasRecipientTag(p, r); });
      });
      if (!poolHasRecipientTags) {
        // no tag data to go on for this occasion pool — don't fake-filter with substrings
        recPool = occPool.slice();
      } else {
        recPool = occPool.filter(function(p){ return productHasRecipientTag(p, rec); });
        if (recPool.length === 0) recPool = occPool.slice();
      }
    }
    resetStep('budget');
    buildBudgetDropdown();
    on('budget');
  });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• STEP 3: BUDGET â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildBudgetDropdown() {
  var drop = document.getElementById('gba-drop-budget');
  drop.innerHTML = '';
  var frag = document.createDocumentFragment();
  BUDGET_OPTIONS.forEach(function(bud) {
    var avail = bud.val === 'anyprice' || recPool.length === 0
      ? true
      : recPool.some(function(p){ return p.price >= bud.min && p.price <= bud.max; });
    var opt = makeOpt(bud.val, bud.label, avail, avail ? (function(b){ return function(){ onBudgetSelected(b); }; }(bud)) : null);
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
  rebindTrigger('budget');
}

function onBudgetSelected(bud) {
  S.budget = bud;
  markPicked('budget', bud.val);
  setLabel('budget', bud.label, bud.val);
  closeAll();
  enableFind();
}

/* â•â•â•â•â•â•â•â•â•â•â•â• FIND & RESULTS â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function bindFind() {
  document.getElementById('gba-btn-find').addEventListener('click', function(){
    if (!S.occasion || !S.recipient || !S.budget) return;
    document.getElementById('gba-loading').style.display = 'block';
    document.getElementById('gba-results').style.display = 'none';
    /* INP fix: use rAF + setTimeout so the loading spinner paints
       before the heavy filter/render work begins. */
    requestAnimationFrame(function() {
      setTimeout(showResults, 50);
    });
  });
}

function showResults() {
  var bud   = S.budget;
  var title = 'Based on your choices we recommend these gifts!';
  if (bud.val === 'anyprice') {
    finalPool = recPool.slice();
  } else {
    finalPool = recPool.filter(function(p){ return p.price >= bud.min && p.price <= bud.max; });
    if (finalPool.length === 0 && recPool.length > 0) {
      finalPool = recPool.slice();
      title = 'Here are our best matches some may be outside your selected budget range.';
    }
  }
  if (finalPool.length === 0 && occPool.length > 0) {
    finalPool = occPool.slice();
    title = 'Here are all available gifts for this occasion!';
  }
  document.getElementById('gba-loading').style.display = 'none';
  document.getElementById('gba-results').style.display = 'block';
  document.getElementById('gba-results-title').textContent = title;
  if (finalPool.length === 0) {
    document.getElementById('gba-grid').style.display  = 'none';
    document.getElementById('gba-empty').style.display = 'block';
    document.getElementById('gba-pages').innerHTML     = '';
  } else {
    document.getElementById('gba-empty').style.display = 'none';
    document.getElementById('gba-grid').style.display  = 'grid';
    renderPage(1);
  }
  scrollTop();
}

/* INP fix: renderPage uses a DocumentFragment and event delegation
   instead of attaching one listener per card button. */
function renderPage(page) {
  var start = (page-1)*PER;
  var items = finalPool.slice(start, start+PER);
  var total = Math.ceil(finalPool.length/PER);
  var grid  = document.getElementById('gba-grid');

  /* Build HTML string (fast) then set once (single reflow). */
  grid.innerHTML = items.map(function(p, i){
    var img = p.image
      ? '<img class="gba-card-img" src="'+esc(p.image)+'" alt="'+esc(p.title)+'" loading="lazy">'
      : '<div class="gba-card-img"></div>';
    var isMulti = (p.variants_count && p.variants_count > 1);
    var btn = isMulti
      ? '<button class="gba-atc gba-quick-add-btn" data-handle="'+esc(p.handle)+'" data-title="'+esc(p.title)+'">'
        +'<span class="gba-atc-spin"></span>'
        +'<svg width="13" height="13" viewBox="0 0 14 14" fill="none" style="margin-right:5px;flex-shrink:0"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
        +'<span class="gba-atc-txt">Quick Add</span>'
        +'</button>'
      : '<button class="gba-atc" data-vid="'+esc(String(p.variant_id||''))+'">'
        +'<span class="gba-atc-spin"></span><span class="gba-atc-txt">Add to Cart</span>'
        +'</button>';
    return '<div class="gba-card" style="animation-delay:'+(i*80)+'ms">'
      +'<a href="'+esc(p.url)+'">'+img
      +'<div class="gba-card-info">'
      +'<div class="gba-card-title">'+esc(p.title)+'</div>'
      +'<div class="gba-card-price">$'+p.price.toFixed(2)+'</div>'
      +'</div></a>'
      +btn
      +'</div>';
  }).join('');

  /* INP fix: single delegated listener on the grid instead of N listeners.
     This replaces the previous per-button addEventListener approach. */
  grid.onclick = function(e) {
    var btn = e.target.closest('.gba-atc');
    if (!btn) return;
    if (btn.classList.contains('gba-quick-add-btn')) {
      var handle = btn.dataset.handle;
      if (handle) openQuickAdd(handle);
    } else {
      addToCart(btn);
    }
  };

  renderPages(page, total);
}

function renderPages(page, total) {
  var el = document.getElementById('gba-pages');
  if (total <= 1) { el.innerHTML = ''; return; }
  var h = '<button class="gba-pg" data-pg="'+(page-1)+'"'+(page===1?' disabled':'')+'>&#8592;</button>';
  function b(n){ h += '<button class="gba-pg'+(n===page?' on':'')+'" data-pg="'+n+'">'+n+'</button>'; }
  function d(){ h += '<button class="gba-pg" disabled>...</button>'; }
  b(1);
  var s=Math.max(2,page-2), e=Math.min(total-1,page+3);
  if(s>2)d(); for(var i=s;i<=e;i++)b(i); if(e<total-1)d();
  if(total>1)b(total);
  h += '<button class="gba-pg" data-pg="'+(page+1)+'"'+(page===total?' disabled':'')+'>&#8594;</button>';
  el.innerHTML = h;
  /* INP fix: delegate pagination clicks one listener, not N. */
  el.onclick = function(e) {
    var btn = e.target.closest('.gba-pg');
    if (!btn || btn.disabled) return;
    var pg = parseInt(btn.dataset.pg, 10);
    if (pg >= 1 && pg <= total) { renderPage(pg); scrollTop(); }
  };
}


function addToCart(btn) {
  if (btn.disabled) return;
  var vid = btn.dataset.vid; if (!vid) return;

  btn.disabled = true;
  btn.classList.add('loading');
  btn.querySelector('.gba-atc-txt').textContent = 'Adding...';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(e){ throw e; });
    btn.classList.remove('loading');
    btn.classList.add('ok');
    btn.querySelector('.gba-atc-txt').textContent = 'Added!';
    refreshCart();
    setTimeout(function() {
      btn.disabled = false;
      btn.classList.remove('ok');
      btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    }, 2200);
  })
  .catch(function(err) {
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    alert((err && err.description) ? err.description : 'Could not add item.');
  });
}


function formatCartMoney(cents) {
  try {
    var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
      ? window.themeHDN.settings.moneyFormat : '${{amount}}';
    return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
  } catch(e) { return '$' + (cents / 100).toFixed(2); }
}

function updateBadge(n, totalFormatted) {
  var hdtCart = document.querySelector('hdt-cart-drawer');
  if (hdtCart) hdtCart.setAttribute('data-count', n);
  document.querySelectorAll('hdt-cart-count').forEach(function(el) {
    el.textContent = n;
    if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
    else { el.style.display = 'none'; }
  });
  if (totalFormatted) {
    document.querySelectorAll('hdt-cart-total').forEach(function(el) { el.textContent = totalFormatted; });
  }
  var sels = ['.hdt-mini-cart__count','.hdt-header__cart-count','[data-cart-count]','[data-header-cart-count]',
    '#cart-icon-bubble','.cart-count-bubble span','.t4s-cart-count','.t4s-cart-icon__count'];
  sels.forEach(function(s) {
    document.querySelectorAll(s).forEach(function(el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
    });
  });
}

function openHDTCart() {
  var hdtCart = document.querySelector('hdt-cart-drawer');
  if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
  var triggerSels = ['[aria-controls="CartDrawer"]','[data-cart-drawer-trigger]',
    '.hdt-header__cart','.hdt-header__icon--cart','button[data-cart]',
    'a[href="/cart"].hdt-header__icon','.t4s-site-nav__cart > a',
    '[data-t4s-open-quickcart]','[data-open-quickcart]','.t4s-cart-icon a'];
  for (var i = 0; i < triggerSels.length; i++) {
    var el = document.querySelector(triggerSels[i]);
    if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
  }
  document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
}

function refreshCart() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateBadge(cart.item_count, formatCartMoney(cart.total_price));
      var hdtCart = document.querySelector('hdt-cart-drawer');
      if (!hdtCart) { openHDTCart(); return; }
      if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
      if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
      var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
      fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data[sectionId] || null;
          if (html) {
            var doc   = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-items-component');
            var live  = document.querySelector('cart-items-component');
            if (fresh && live) live.replaceWith(fresh);
          }
          openHDTCart();
        })
        .catch(function() { openHDTCart(); });
    })
    .catch(function() { openHDTCart(); });
}


function bindRestart() {
  document.querySelectorAll('.gba-btn-restart').forEach(function(btn){
    btn.addEventListener('click', function(){
      S = { occasion:null, recipient:null, budget:null };
      occPool=[]; recPool=[]; finalPool=[];
      ['occasion','recipient','budget'].forEach(resetStep);
      on('occasion'); disableFind();
      document.getElementById('gba-results').style.display = 'none';
      document.getElementById('gba-loading').style.display = 'none';
      scrollTop();
    });
  });
}

function makeOpt(iconKey, label, available, clickFn) {
  var div       = document.createElement('div');
  div.className = 'gba-opt' + (available ? '' : ' gba-dim');
  div.dataset.val = iconKey;
  addIcon(div, iconKey);
  div.appendChild(document.createTextNode(label));
  if (clickFn) div.addEventListener('click', clickFn);
  return div;
}

function addIcon(el, key) {
  if (!ICONS[key] || el.querySelector('.gba-ico')) return;
  var sp = document.createElement('span');
  sp.className = 'gba-ico';
  sp.innerHTML = ICONS[key];
  el.insertBefore(sp, el.firstChild);
}

function rebindTrigger(key) {
  // No-op — bindTrigger() already attached a permanent listener
  // for this trigger in init(), so nothing needs re-binding.
}

function bindTrigger(key) {
  var trig = document.getElementById('gba-trig-' + key);
  var cs   = document.getElementById('gba-cs-' + key);
  trig.addEventListener('click', function(e){
    e.stopPropagation();
    if (cs.classList.contains('gba-off')) return;
    var open = cs.classList.contains('gba-open');
    closeAll();
    if (!open) cs.classList.add('gba-open');
  });
}

function markPicked(key, val) {
  var drop = document.getElementById('gba-drop-' + key);
  if (drop) drop.querySelectorAll('.gba-opt').forEach(function(o){
    o.classList.toggle('gba-sel', o.dataset.val === val);
  });
  var cs = document.getElementById('gba-cs-' + key);
  if (cs) cs.classList.add('gba-picked');
}

function setLabel(key, text, iconKey) {
  var lbl = document.getElementById('gba-lbl-' + key);
  if (!lbl) return;
  var svg = ICONS[iconKey] || '';
  lbl.innerHTML = svg
    ? '<span class="gba-trico">' + svg + '</span>' + esc(text)
    : '';
  if (!svg) lbl.textContent = text;
  lbl.classList.add('v');
}

function on(key) {
  var cs = document.getElementById('gba-cs-' + key);
  if (cs) cs.classList.remove('gba-off');
}

function resetStep(key) {
  var cs       = document.getElementById('gba-cs-' + key);
  var lbl      = document.getElementById('gba-lbl-' + key);
  var drop     = document.getElementById('gba-drop-' + key);
  var defaults = { occasion:'Occasion', recipient:'Recipient', budget:'Budget' };
  if (cs)   { cs.classList.add('gba-off'); cs.classList.remove('gba-picked','gba-open'); }
  if (lbl)  { lbl.textContent = defaults[key]; lbl.classList.remove('v'); }
  if (drop) { drop.querySelectorAll('.gba-opt').forEach(function(o){ o.classList.remove('gba-sel'); }); }
}

function enableFind()  { var b=document.getElementById('gba-btn-find'); if(b){b.disabled=false;b.classList.remove('gba-off');} }
function disableFind() { var b=document.getElementById('gba-btn-find'); if(b){b.disabled=true; b.classList.add('gba-off');} }

function closeAll() {
  ['occasion','recipient','budget'].forEach(function(k){
    var cs=document.getElementById('gba-cs-'+k); if(cs) cs.classList.remove('gba-open');
  });
}

function stepLoading(show) {
  document.getElementById('gba-step-loading').style.display = show ? 'block' : 'none';
  if (show) {
    ['recipient','budget'].forEach(function(k){
      var cs=document.getElementById('gba-cs-'+k); if(cs) cs.classList.add('gba-off');
    });
  }
}

function esc(s) {
  return String(s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function scrollTop() {
  var w = document.querySelector('.gba-wrapper');
  if (w) window.scrollTo({ top: w.offsetTop - 20, behavior:'smooth' });
}

/* 
   QUICK ADD MODAL
 */
var QA = { overlay:null, modal:null, product:null, selectedOptions:{}, selectedVariant:null };

function initQuickAdd() {
  QA.overlay = document.getElementById('gba-qa-overlay');
  QA.modal   = document.getElementById('gba-qa-modal');
  document.getElementById('gba-qa-close').addEventListener('click', closeQuickAdd);
  QA.overlay.addEventListener('click', function(e){ if (e.target === QA.overlay) closeQuickAdd(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeQuickAdd(); });
  document.getElementById('gba-qa-atc').addEventListener('click', modalAddToCart);
}

function openQuickAdd(handle) {
  QA.product = null; QA.selectedOptions = {}; QA.selectedVariant = null;
  document.getElementById('gba-qa-loading').style.display = 'flex';
  document.getElementById('gba-qa-content').style.display = 'none';
  document.getElementById('gba-qa-main-img').src = '';
  document.getElementById('gba-qa-thumbs').innerHTML = '';
  QA.overlay.classList.add('gba-qa-open');
  QA.overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  fetch('/products/' + handle + '.js')
    .then(function(r){ return r.json(); })
    .then(function(product){ QA.product = product; populateModal(product); })
    .catch(function(){ closeQuickAdd(); alert('Could not load product details.'); });
}

function populateModal(product) {
  var rawImages = product.images || [];
  var imageUrls = rawImages.map(function(img){
    return typeof img === 'string' ? img : (img && img.src ? img.src : '');
  }).filter(Boolean);
  if (imageUrls.length === 0 && product.featured_image) {
    var fi = product.featured_image;
    imageUrls = [typeof fi === 'string' ? fi : (fi && fi.src ? fi.src : '')];
  }

  var mainImgEl = document.getElementById('gba-qa-main-img');
  var thumbsEl  = document.getElementById('gba-qa-thumbs');
  var firstUrl  = imageUrls[0] || '';
  mainImgEl.src = firstUrl ? (firstUrl + (firstUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=800') : '';
  mainImgEl.alt = product.title || '';

  thumbsEl.innerHTML = '';
  var thumbFrag = document.createDocumentFragment();
  imageUrls.slice(0, 8).forEach(function(url, idx){
    var th = document.createElement('img');
    th.className = 'gba-qa-thumb' + (idx === 0 ? ' active' : '');
    th.src = url; th.alt = (product.title || '') + ' ' + (idx + 1); th.loading = 'lazy';
    th.addEventListener('click', function(){
      mainImgEl.style.opacity = '0';
      setTimeout(function(){ mainImgEl.src = url; mainImgEl.style.opacity = '1'; }, 120);
      thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(t){ t.classList.remove('active'); });
      th.classList.add('active');
    });
    thumbFrag.appendChild(th);
  });
  thumbsEl.appendChild(thumbFrag);

  var productUrl = '/products/' + product.handle;
  document.getElementById('gba-qa-title').textContent = product.title;
  document.getElementById('gba-qa-title-link').href   = productUrl;
  document.getElementById('gba-qa-view-link').href    = productUrl;
  document.getElementById('gba-qa-desc').innerHTML    = product.description || '<em style="color:#aaa">No description available.</em>';

  var variants = product.variants || [];
  var options  = product.options  || [];
  var firstAvail = variants.find(function(v){ return v.available; }) || variants[0];
  if (firstAvail) {
    options.forEach(function(opt, i){ QA.selectedOptions[opt.name] = firstAvail['option' + (i + 1)]; });
  }
  buildVariantPicker(variants, options);
  syncModalVariant();

  document.getElementById('gba-qa-loading').style.display = 'none';
  var c = document.getElementById('gba-qa-content');
  c.style.display = 'flex'; c.style.flexDirection = 'column'; c.style.flex = '1';
}

function buildVariantPicker(variants, options) {
  var container = document.getElementById('gba-qa-options');
  container.innerHTML = '';
  if (options.length === 1 && options[0].name === 'Title' && variants.length === 1) return;

  var frag = document.createDocumentFragment();
  options.forEach(function(opt, optIdx){
    var group = document.createElement('div'); group.className = 'gba-qa-opt-group';
    var lbl   = document.createElement('span'); lbl.className = 'gba-qa-opt-label';
    lbl.dataset.optName = opt.name;
    lbl.innerHTML = esc(opt.name) + ': <em>' + esc(QA.selectedOptions[opt.name] || '') + '</em>';
    group.appendChild(lbl);

    var pills = document.createElement('div'); pills.className = 'gba-qa-pills';
    var seen  = {};
    (opt.values || []).forEach(function(val){
      if (seen[val]) return; seen[val] = true;
      var hasAvail = variants.some(function(v){ return v['option'+(optIdx+1)] === val && v.available; });
      var pill = document.createElement('button');
      pill.type = 'button'; pill.textContent = val;
      pill.className = 'gba-qa-pill' + (QA.selectedOptions[opt.name] === val ? ' selected' : '') + (hasAvail ? '' : ' sold-out');
      pill.dataset.optName = opt.name; pill.dataset.optValue = val;
      if (hasAvail) {
        pill.addEventListener('click', function(){
          QA.selectedOptions[opt.name] = val;
          pills.querySelectorAll('.gba-qa-pill').forEach(function(p){ p.classList.remove('selected'); });
          pill.classList.add('selected');
          lbl.innerHTML = esc(opt.name) + ': <em>' + esc(val) + '</em>';
          syncModalVariant();
        });
      }
      pills.appendChild(pill);
    });
    group.appendChild(pills);
    frag.appendChild(group);
  });
  container.appendChild(frag);
}

function syncModalVariant() {
  if (!QA.product) return;
  var variants = QA.product.variants || [];
  var options  = QA.product.options  || [];
  var matched  = variants.find(function(v){
    return options.every(function(opt, i){ return v['option'+(i+1)] === QA.selectedOptions[opt.name]; });
  }) || variants[0];
  QA.selectedVariant = matched;

  if (matched && matched.featured_image) {
    var fi = matched.featured_image;
    var varImgUrl = typeof fi === 'string' ? fi : (fi && fi.src ? fi.src : '');
    if (varImgUrl) {
      var mainImgEl = document.getElementById('gba-qa-main-img');
      var thumbsEl  = document.getElementById('gba-qa-thumbs');
      mainImgEl.style.opacity = '0';
      setTimeout(function(){ mainImgEl.src = varImgUrl; mainImgEl.style.opacity = '1'; }, 130);
      var baseFi = varImgUrl.split('?')[0];
      thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(th){
        if ((th.src || '').split('?')[0] === baseFi) {
          thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(t){ t.classList.remove('active'); });
          th.classList.add('active');
        }
      });
    }
  }

  var priceEl = document.getElementById('gba-qa-price');
  if (matched) priceEl.textContent = '$' + (parseFloat(matched.price) / 100).toFixed(2);

  var atcBtn = document.getElementById('gba-qa-atc');
  if (matched && matched.available) {
    atcBtn.disabled = false;
    atcBtn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
  } else {
    atcBtn.disabled = true;
    atcBtn.querySelector('.gba-atc-txt').textContent = 'Sold Out';
  }
}

function closeQuickAdd() {
  if (!QA.overlay) return;
  QA.overlay.classList.remove('gba-qa-open');
  QA.overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function modalAddToCart() {
  if (!QA.selectedVariant || !QA.selectedVariant.id) return;
  var btn = document.getElementById('gba-qa-atc');
  if (btn.disabled) return;
  btn.disabled = true; btn.classList.add('loading');
  btn.querySelector('.gba-atc-txt').textContent = 'Adding...';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ id: parseInt(QA.selectedVariant.id, 10), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(e){ throw e; });
    btn.classList.remove('loading'); btn.classList.add('ok');
    btn.querySelector('.gba-atc-txt').textContent = 'Added!';
    refreshCart();
    setTimeout(function(){
      closeQuickAdd();
      setTimeout(function(){
        btn.disabled = false; btn.classList.remove('ok');
        btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
      }, 300);
    }, 900);
  })
  .catch(function(err){
    btn.disabled = false; btn.classList.remove('loading');
    btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    alert((err && err.description) ? err.description : 'Could not add item.');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){ init(); initQuickAdd(); });
} else {
  init(); initQuickAdd();
}

}());
